// @flow
import * as React from 'react';
import classnames from 'classnames';
import { PlusOutlined } from '@ant-design/icons';
import { SortableElement } from 'react-sortable-hoc';
import styles from './Footer.css';

import type {
  AddEstimateCaveatParams
} from '../../../types';

type Props = {
  editable: boolean,
  onClickAddEstimateCaveat: (params: AddEstimateCaveatParams) => void,
  onClickSelectCaveatFromList: () => void
}

class Component extends React.PureComponent<Props> {

  render () {

    const {
      editable,
      onClickAddEstimateCaveat,
      onClickSelectCaveatFromList
    } = this.props;

    return (
      <div
        className={styles.wrapper}
      >

        {editable && (

          <React.Fragment>
          
            <div
              className={classnames(styles.link, styles.addLink)}
              onClick={() => onClickSelectCaveatFromList({})}
              role="presentation"
            >
              <PlusOutlined />
              {' Add From List'}
            </div>

            <div
              className={classnames(styles.link)}
              onClick={() => onClickAddEstimateCaveat({})}
              role="presentation"
            >
              <PlusOutlined />
              {' Add Blank Caveat'}
            </div>

          </React.Fragment>
          
        )}

      </div>
    );
  }
}

export default SortableElement(Component);